import { z } from "zod";

// Define the DayOfWeek type
export type DayOfWeek = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

// Create the schema using centralized types
const detailedOpeningHoursSchema = z.object({
  monday: z.object({
    isOpen: z.boolean(),
    from: z.string(),
    to: z.string(),
  }),
  tuesday: z.object({
    isOpen: z.boolean(),
    from: z.string(),
    to: z.string(),
  }),
  wednesday: z.object({
    isOpen: z.boolean(),
    from: z.string(),
    to: z.string(),
  }),
  thursday: z.object({
    isOpen: z.boolean(),
    from: z.string(),
    to: z.string(),
  }),
  friday: z.object({
    isOpen: z.boolean(),
    from: z.string(),
    to: z.string(),
  }),
  saturday: z.object({
    isOpen: z.boolean(),
    from: z.string(),
    to: z.string(),
  }),
  sunday: z.object({
    isOpen: z.boolean(),
    from: z.string(),
    to: z.string(),
  }),
});

export const terraceFormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  type: z.string().min(1, "Type is required"),
  address: z.string().min(1, "Address is required"),
  lat: z.number().optional(),
  lng: z.number().optional(),
  openingHours: z.string().optional(),
  openingDays: z.array(z.string()).optional(),
  detailedOpeningHours: detailedOpeningHoursSchema,
  orientation: z.enum(["N", "NE", "E", "SE", "S", "SW", "W", "NW", "unknown"]).default("unknown"),
  hasFood: z.boolean(),
  petFriendly: z.boolean(),
  servesAlcohol: z.boolean(),
  wheelchairAccessible: z.boolean(),
  servesWine: z.boolean(),
  servesBeer: z.boolean(),
  allowsDogs: z.boolean(),
  terraceDescription: z.string().optional(),
  website: z.string().optional(),
  phone: z.string().optional(),
  sunStatus: z.enum(["sunny", "soon", "not-sunny"]),
  submitterName: z.string().optional(),
  photo_url: z.string().optional(),
  // Add the Google Maps URL as optional
  googleMapsUrl: z.string().optional()
});

export type TerraceFormValues = z.infer<typeof terraceFormSchema>;
